import { useGetTasks, type KdsTaskDetail } from '@ordr-as/ordr-service-types/epos';
import { useOrdersWebSocketStore } from '../context/OrdersWebSocketStore';

/**
 * KDS tasks for a location. The react-query cache is the single source of
 * truth: the websocket provider writes snapshots/updates straight into it,
 * and polling is only a safety net (tighter while the socket is down).
 */
export function useKdsTasks(
  locationId: number,
  options?: { enabled?: boolean },
): ReturnType<typeof useGetTasks<KdsTaskDetail[]>> {
  const connectionState = useOrdersWebSocketStore((s) => s.connectionState);
  return useGetTasks(locationId, {
    query: {
      enabled: options?.enabled ?? true,
      refetchInterval: connectionState === 'connected' ? 15_000 : 5_000,
      refetchOnWindowFocus: true,
    },
  });
}
